/**
 * Backoffice display of an account's commercial plan.
 *
 * Activation lifts `accounts.tier` to `ecommerce` so legacy capability gates
 * keep working. That internal dial must never be what sales sees — a Business
 * bundle customer is on Business, not the old website ecommerce tier.
 */

export const BUNDLE_TIER_KEYS = ['growth', 'business', 'scale'];

export const BUNDLE_TIER_LABELS = {
  growth: 'Growth',
  business: 'Business',
  scale: 'Scale',
};

export function isBundleAccount(account) {
  return account?.billing_model === 'engagement_bundle' && Boolean(account?.bundle_tier);
}

export function getAccountPlanKey(account) {
  if (!account) return 'free';
  if (account.display_tier) return account.display_tier;
  if (isBundleAccount(account)) return account.bundle_tier;
  return account.tier || 'free';
}

export function getAccountPlanLabel(account) {
  const key = typeof account === 'string' ? account : getAccountPlanKey(account);
  if (BUNDLE_TIER_LABELS[key]) return BUNDLE_TIER_LABELS[key];
  if (key === 'landing_page') return 'Landing Page';
  if (key === 'ecommerce') return 'E-commerce';
  if (!key) return 'Free';
  return key.charAt(0).toUpperCase() + key.slice(1);
}

export function getAccountPlanBadgeClass(accountOrTier) {
  const key = typeof accountOrTier === 'string'
    ? accountOrTier
    : getAccountPlanKey(accountOrTier);
  switch (key) {
    case 'growth':
      return 'bg-sky-100 text-sky-800';
    case 'business':
      return 'bg-indigo-100 text-indigo-800';
    case 'scale':
      return 'bg-violet-100 text-violet-800';
    case 'free':
    case 'trial':
      return 'bg-green-100 text-green-800';
    case 'pro':
      return 'bg-purple-100 text-purple-800';
    case 'ecommerce':
      return 'bg-blue-100 text-blue-800';
    case 'landing_page':
      return 'bg-green-100 text-green-700';
    case 'enterprise':
      return 'bg-yellow-100 text-yellow-800';
    default:
      return 'bg-gray-100 text-gray-800';
  }
}
